class ProductDisplay {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.prevButton = container.querySelectorAll('.mt-product-display__nav-button--prev');
    this.nextButton = container.querySelectorAll('.mt-product-display__nav-button--next');
    this.swiper = null;
    this.init();
  }

  init() {
    this.initSecondaryImageHover();

    if (typeof Swiper === 'undefined') {
      this.loadSwiper().then(() => {
        this.initSwiper();
      });
    } else {
      this.initSwiper();
    }
  }

  /**
   * 预加载第二张图：进入视口或悬停/聚焦时提前暖缓存，减少首次悬停延迟。
   */
  initSecondaryImageHover() {
    const cards = this.container.querySelectorAll(
      '.mt-product-card--has-secondary, .mt-product-card:has(.mt-product-card__image--secondary)'
    );

    cards.forEach((card) => {
      const secondary = card.querySelector('.mt-product-card__image--secondary');
      if (!secondary) return;

      card.classList.add('mt-product-card--has-secondary');

      const preload = () => {
        if (secondary.complete && secondary.naturalWidth > 0) return;

        if (secondary.loading === 'lazy') {
          secondary.loading = 'eager';
        }

        if (typeof secondary.decode === 'function') {
          secondary.decode().catch(() => {});
          return;
        }

        const warmer = new Image();
        warmer.decoding = 'async';
        warmer.src = secondary.currentSrc || secondary.src;
      };

      secondary.addEventListener(
        'error',
        () => {
          card.classList.remove('mt-product-card--has-secondary');
          secondary.remove();
        },
        { once: true }
      );

      card.addEventListener('pointerenter', preload, { passive: true });
      card.addEventListener('focusin', preload, { passive: true });

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              preload();
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '120px 0px' }
        );
        io.observe(card);
      }
    });
  }

  loadSwiper() {
    return new Promise((resolve, reject) => {
      const swiperCSS = document.createElement('link');
      swiperCSS.rel = 'stylesheet';
      swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      document.head.appendChild(swiperCSS);

      const swiperScript = document.createElement('script');
      swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      swiperScript.onload = resolve;
      swiperScript.onerror = reject;
      document.head.appendChild(swiperScript);
    });
  }

  initSwiper() {
    const swiperEl = this.container.querySelector('.mt-product-display__slider');

    // 销毁旧实例，避免重复初始化
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const isMobile = window.innerWidth < 768;

    this.swiper = new Swiper(swiperEl, {
      // ---- 移动端默认配置 (<768px): 2列 x 2行，每页4个 ----
      slidesPerView: 2,
      spaceBetween: 8,  // 同时控制列间距和行间距
      slidesPerGroup: 2,  // Swiper Grid 模式：slidesPerGroup = slidesPerView
      speed: 600,
      grid: {
        rows: 2,
        fill: 'row'
      },
      breakpoints: {
        // ---- 平板 (768px+): 3列 1行 ----
        768: {
          slidesPerView: 3,
          spaceBetween: 5,
          slidesPerGroup: 3,
          grid: {
            rows: 1,
            fill: 'row'
          }
        },
        // ---- 桌面 (1024px+): 4列 1行 ----
        1024: {
          slidesPerView: 4,
          spaceBetween: 5,
          slidesPerGroup: 4,
          grid: {
            rows: 1,
            fill: 'row'
          }
        }
      },
      on: {
        init: (swiper) => {
          this.updateNavButtons(swiper);
        },
        slideChange: (swiper) => {
          this.updateNavButtons(swiper);
        },
        breakpoint: (swiper) => {
          this.updateNavButtons(swiper);
        }
      }
    });

    this.prevButton.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-disabled')) return;
        this.swiper.slidePrev();
      });
    });

    this.nextButton.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-disabled')) return;
        this.swiper.slideNext();
      });
    });
  }

  updateNavButtons(swiper) {
    this.prevButton.forEach((btn) => {
      btn.classList.toggle('is-disabled', swiper.isBeginning);
    });
    this.nextButton.forEach((btn) => {
      btn.classList.toggle('is-disabled', swiper.isEnd);
    });
  }
}

window.ProductDisplay = ProductDisplay;

// 初始化所有实例（Related products 异步加载后由 related-products.js 再初始化）
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mt-product-display').forEach((el) => {
    if (el.closest('product-recommendations.related-products')) return;
    new ProductDisplay(el);
  });
});

// Shopify 主题编辑器支持
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.mt-product-display');
    if (container && !container.closest('product-recommendations.related-products')) {
      new ProductDisplay(container);
    }
  });
}
